import { useTranslation } from "react-i18next";
import { DeptCard } from "./DeptCard";

// معاينة حيّة لبطاقة القسم كما ستظهر في القائمة تمامًا — تحاكي الشكل النهائي.
export const DeptPreview = ({ form, managers, initial }) => {
  const { t } = useTranslation();
  const manager = form.manager_id
    ? managers.find((m) => m.id === form.manager_id) : null;
  const fakeDept = {
    id: initial?.id || "preview",
    name_ar: form.name_ar || t("departments.form.previewNameAr"),
    name_en: form.name_en || t("departments.form.previewNameEn"),
    code: form.code ? form.code.toUpperCase() : null,
    description: form.description || null,
    description_en: form.description_en || null,
    color: form.color,
    icon_key: form.icon_key,
    manager: manager
      ? { id: manager.id, name: manager.name, name_ar: manager.name_ar,
          email: manager.email }
      : null,
    member_count: initial?.member_count ?? 0,
  };
  return (
    <aside className="lg:sticky lg:top-4" data-testid="dept-preview">
      <p className="mb-3 flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
        <span className="inline-flex h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
        {t("departments.form.livePreview")}
      </p>
      <DeptCard dept={fakeDept} canEdit={false} canDelete={false} />
      <p className="mt-3 rounded-2xl bg-muted/30 p-3 text-[10px] leading-5 text-muted-foreground">
        {t("departments.form.previewNote")}
      </p>
    </aside>
  );
};
